var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveUpdateIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-1155 -1397.429)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Icon.BG",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(1155 1397.429)",
    fill: "#fdebb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Process",
    d: "M8.764,8.347A4.851,4.851,0,0,1,5.355,9.738,4.674,4.674,0,0,1,1.948,8.347,4.577,4.577,0,0,1,.626,5.7l1.391-.21A3.758,3.758,0,0,0,2.99,7.373a3.485,3.485,0,0,0,4.869,0L6.4,5.912l4.451-.488-.556,4.452ZM.486,0,2.018,1.53a4.912,4.912,0,0,1,6.885,0,4.583,4.583,0,0,1,1.322,2.643l-1.391.21A3.754,3.754,0,0,0,7.859,2.5a3.485,3.485,0,0,0-4.869,0l1.461,1.46L0,4.452Z",
    transform: "translate(1162.651 1405.346)",
    fill: "#fdb937"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUpdateIcon);
export default __webpack_public_path__ + "static/media/active_update_icon.9aca502e2b2643041d6c07552c30bf62.svg";
export { ForwardRef as ReactComponent };